/* eslint-disable react/no-unused-state */
/* eslint-disable camelcase */
/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import globalURL from 'helper/url';
import ActivityIndicator from '@lyearn-team/frontend-components/dist/Loader';
import Icon from '@lyearn-team/frontend-components/dist/Icon';
import { getQueryStringVal } from 'helper/QueryString';
import DarkBoxInput from '@lyearn-team/frontend-components/dist/Input/DarkBoxInput';
import DarkButton from '@lyearn-team/frontend-components/dist/Button/DarkButton';
import { ConfirmPasswordErrors } from '../shared/consts';
import { getQueryParams } from '../shared/static';

import {
  FixWidthColumn,
  CompanyPageWrapper,
  GlobalMessage,
  inputClass,
  buttonClass,
  validationMsgClass,
  greenMsgClass,
  checkRightClass,
  msgDivClass,
  passwordWrapperClass,
  passwordInputClass,
  ConfirmPasswordInputDiv
} from './styles';
import { LoginContentHeading, LoginNormalText } from '../styles';

export default class DarkConfirmPassword extends Component {
  constructor(props) {
    super(props);
    const queryString = window.location.search;
    const queryParams = getQueryParams(queryString);
    this.state = {
      confirmationCode: queryParams && queryParams.c && decodeURIComponent(queryParams.c),
      loading: false,
      errorMessage: '',
      userName: queryParams && queryParams.u && decodeURIComponent(queryParams.u),
      password: '',
      globalError: '',
      passwordUpperLowerError: '',
      passwordUpperError: '',
      passwordLowerError: '',
      passwordNumeric: '',
      passwordSpecialChar: '',
      passwordMinChar: '',
      minimumLength: '',
      isNumeric: false,
      isUppercase: false,
      isLowercase: false,
      isSpecialChar: false,
      isNumericValue: false,
      isUppercaseValue: false,
      isLowercaseValue: false,
      isUpperLowerValue: false,
      isSpecialCharValue: false,
      minimumLengthValue: false
    };
  }

  UNSAFE_componentWillMount() {
    const subDomain =
      getQueryStringVal('cn', window.location.href) || window.location.host.split('.')[0];

    fetch(globalURL.awsEndpoint + '/fetchcompanyinfo', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({
        cmd: 'companyBySubDomain',
        mutationProps: {
          subDomain
        }
      })
    })
      .then(response => response.json())
      .then(response => {
        this.minimumLength = response.passwordPolicy.MinimumLength;
        this.isNumeric = response.passwordPolicy.RequireNumbers;
        this.isUppercase = response.passwordPolicy.RequireUppercase;
        this.isLowercase = response.passwordPolicy.RequireLowercase;
        this.isSpecialChar = response.passwordPolicy.RequireSymbols;

        this.setState({
          minimumLength: this.minimumLength,
          isNumeric: this.isNumeric,
          isUppercase: this.isUppercase,
          isLowercase: this.isLowercase,
          isSpecialChar: this.isSpecialChar
        });
      })
      .catch(error => {
        console.log('Error in fetching/saving tokens', error);
      });
  }

  onPasswordChange = e => {
    this.clearAllState();

    const pass = e.target.value;

    const regPasswordUpperLower = new RegExp('(?=.*[a-z])(?=.*[A-Z]).*');
    const checkPasswordUpperLower = regPasswordUpperLower.test(pass);

    if (this.isUppercase && this.isLowercase) {
      if (checkPasswordUpperLower) {
        this.setState({ passwordUpperLowerError: greenMsgClass, isUpperLowerValue: true });
      } else {
        this.setState({ passwordUpperLowerError: '', isUpperLowerValue: false });
      }
    } else {
      this.setState({ isUpperLowerValue: true });
    }

    const regPasswordUpper = new RegExp('(?=.*[A-Z]).*');
    const checkPasswordUpper = regPasswordUpper.test(pass);

    if (this.isUppercase && !this.isLowercase) {
      if (checkPasswordUpper) {
        this.setState({ passwordUpperError: greenMsgClass, isUppercaseValue: true });
      } else {
        this.setState({ passwordUpperError: '', isUppercaseValue: false });
      }
    } else {
      this.setState({ isUppercaseValue: true });
    }

    const regPasswordLower = new RegExp('(?=.*[a-z]).*');
    const checkPasswordLower = regPasswordLower.test(pass);

    if (!this.isUppercase && this.isLowercase) {
      if (checkPasswordLower) {
        this.setState({ passwordLowerError: greenMsgClass, isLowercaseValue: true });
      } else {
        this.setState({ passwordLowerError: '', isLowercaseValue: false });
      }
    } else {
      this.setState({ isLowercaseValue: true });
    }

    const regNumeric = new RegExp('(?=.*[0-9])');
    const checkNumeric = regNumeric.test(pass);

    if (this.isNumeric) {
      if (checkNumeric) {
        this.setState({ passwordNumeric: greenMsgClass, isNumericValue: true });
      } else {
        this.setState({ passwordNumeric: '', isNumericValue: false });
      }
    } else {
      this.setState({ isNumericValue: true });
    }

    const regSpecialChar = new RegExp('(?=.*[!@#$%^&*])');
    const checkSpecialChar = regSpecialChar.test(pass);

    if (this.isSpecialChar) {
      if (checkSpecialChar) {
        this.setState({ passwordSpecialChar: greenMsgClass, isSpecialCharValue: true });
      } else {
        this.setState({ passwordSpecialChar: '', isSpecialCharValue: false });
      }
    } else {
      this.setState({ isSpecialCharValue: true });
    }

    if (pass.length > this.minimumLength) {
      this.setState({ passwordMinChar: greenMsgClass, minimumLengthValue: true });
    } else {
      this.setState({ passwordMinChar: '', minimumLengthValue: false });
    }

    this.setState({ password: e.target.value });
  };

  onUserNameChange = e => {
    this.clearAllState();
    this.setState({ userName: e.target.value });
  };

  onCodeChange = e => {
    this.clearAllState();
    this.setState({ confirmationCode: e.target.value });
  };

  onEnter = e => {
    if (e.keyCode === 13) {
      if (
        this.state.isNumericValue &&
        this.state.isSpecialCharValue &&
        this.state.minimumLengthValue &&
        this.state.isUppercaseValue &&
        this.state.isLowercaseValue &&
        this.state.isUpperLowerValue
      ) {
        this.confirmPassword();
      }
    }
  };

  clearAllState = () => {
    const { errorMessage, globalError } = this.state;
    if (errorMessage) {
      this.setState({ errorMessage: '' });
    }
    if (globalError) {
      this.setState({ globalError: '' });
    }
  };

  validateInputs = () => {
    const { password, userName, confirmationCode } = this.state;
    if (!userName) {
      this.setState({ errorMessage: ConfirmPasswordErrors.USERNAME_REQUIRED });
      return false;
    }
    if (!confirmationCode) {
      this.setState({ errorMessage: ConfirmPasswordErrors.CODE_REQUIRED });
      return false;
    }
    if (!password) {
      this.setState({ errorMessage: ConfirmPasswordErrors.PASSWORD_REQUIRED });
      return false;
    }
    return true;
  };

  confirmPassword = event => {
    event.preventDefault();
    if (!this.validateInputs()) return false;
    const { userName, password, confirmationCode } = this.state;
    const awsEndpoint = globalURL.awsEndpoint;
    const cn = window.location.hostname.split('.')[0];
    const self = this;
    const confirmCodeURL = `${awsEndpoint}/updatePassword?challengeName=CONFIRM_FORGOT_PASSWORD&cn=${cn}`;
    this.setState({ loading: true });
    fetch(confirmCodeURL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userName,
        confirmationCode,
        password
      })
    })
      .then(response => response.json())
      .then(response => {
        self.setState({ loading: false });
        if (response.error) {
          throw new Error(JSON.stringify(response.error));
        }
        window.location.href = '/#/login';
      })
      .catch(error => {
        self.setState({ loading: false });
        const errorMessage = error.message;
        let errorObject = {};
        try {
          errorObject = JSON.parse(errorMessage);
        } catch (err) {} // eslint-disable-line no-empty
        switch (errorObject.code) {
          case 'InvalidPasswordException':
          case 'ExpiredCodeException':
          case 'CodeMismatchException':
            self.setState({ globalError: errorObject.message });
            break;
          default:
            self.setState({ globalError: 'Something went wrong!!' });
            console.log('Error is', errorMessage);
            break;
        }
      });
    return true;
  };

  rightIcon = () => <Icon type="checkGreen" style={{ width: '12px', height: '10px' }} />;

  renderActivityIndicator = () => (
    <ActivityIndicator
      svgColor="#fff"
      style={{ marginRight: '6px', fill: '#fff' }}
      width={16}
      height={16}
    />
  );

  render() {
    const {
      password,
      userName,
      confirmationCode,
      loading,
      errorMessage,
      globalError,
      passwordUpperLowerError,
      passwordNumeric,
      passwordSpecialChar,
      passwordMinChar,
      isNumericValue,
      isSpecialCharValue,
      minimumLengthValue,
      isUppercaseValue,
      isLowercaseValue,
      isUpperLowerValue,
      passwordLowerError,
      passwordUpperError
    } = this.state;

    let isDisableButton = true;

    if (
      isNumericValue &&
      isSpecialCharValue &&
      minimumLengthValue &&
      isUppercaseValue &&
      isLowercaseValue &&
      isUpperLowerValue
    ) {
      isDisableButton = false;
    } else {
      isDisableButton = true;
    }

    let icon = '';
    if (loading) {
      icon = this.renderActivityIndicator();
    }

    const rightIcon = this.rightIcon();
    return (
      <CompanyPageWrapper className="pageWrapper">
        {/* {window.bowser.mobile ? <FixMargin /> : ''} */}
        <LoginContentHeading>Reset Your Password</LoginContentHeading>
        <LoginNormalText>Set a new password</LoginNormalText>
        <form className={FixWidthColumn} onSubmit={this.confirmPassword}>
          <div className={ConfirmPasswordInputDiv}>
            <DarkBoxInput
              placeholder="Email"
              value={userName}
              onChange={this.onUserNameChange}
              required={true}
              className={inputClass}
              type="email"
              disabled={true}
            />
            <DarkBoxInput
              placeholder="Authentication Code"
              value={confirmationCode}
              onChange={this.onCodeChange}
              required={true}
              className={inputClass}
              disabled={true}
            />
            <DarkBoxInput.Password
              placeholder="Enter New Password"
              value={password}
              required={true}
              onChange={this.onPasswordChange}
              className={passwordInputClass}
              passwordWrapperClassName={passwordWrapperClass}
            />

            {this.isUppercase && this.isLowercase ? (
              <div className={msgDivClass}>
                {' '}
                <span className={validationMsgClass + ' ' + passwordUpperLowerError}>
                  *Requires Uppercase and Lowercase (A - Z, a - z)
                </span>{' '}
                {passwordUpperLowerError ? (
                  <span className={checkRightClass}> {rightIcon} </span>
                ) : (
                  ''
                )}{' '}
              </div>
            ) : (
              ''
            )}
            {this.isUppercase && !this.isLowercase ? (
              <div className={msgDivClass}>
                {' '}
                <span className={validationMsgClass + ' ' + passwordUpperError}>
                  *Requires Uppercase (A - Z)
                </span>{' '}
                {passwordUpperError ? <span className={checkRightClass}> {rightIcon} </span> : ''}{' '}
              </div>
            ) : (
              ''
            )}
            {!this.isUppercase && this.isLowercase ? (
              <div className={msgDivClass}>
                {' '}
                <span className={validationMsgClass + ' ' + passwordLowerError}>
                  *Requires Lowercase (a - z)
                </span>{' '}
                {passwordLowerError ? <span className={checkRightClass}> {rightIcon} </span> : ''}{' '}
              </div>
            ) : (
              ''
            )}
            {this.isNumeric ? (
              <div className={msgDivClass}>
                {' '}
                <span className={validationMsgClass + ' ' + passwordNumeric}>
                  *Requires a numeric character (0-9)
                </span>{' '}
                {passwordNumeric ? <span className={checkRightClass}> {rightIcon} </span> : ''}{' '}
              </div>
            ) : (
              ''
            )}
            {this.isSpecialChar ? (
              <div className={msgDivClass}>
                {' '}
                <span className={validationMsgClass + ' ' + passwordSpecialChar}>
                  *Requires a special character (!, #, “, $, % etc.)
                </span>{' '}
                {passwordSpecialChar ? <span className={checkRightClass}> {rightIcon} </span> : ''}{' '}
              </div>
            ) : (
              ''
            )}
            {this.minimumLength ? (
              <div className={msgDivClass}>
                {' '}
                <span className={validationMsgClass + ' ' + passwordMinChar}>
                  *Should be more than &nbsp; {this.minimumLength} characters
                </span>{' '}
                {passwordMinChar ? <span className={checkRightClass}> {rightIcon} </span> : ''}{' '}
              </div>
            ) : (
              ''
            )}
            <GlobalMessage>{globalError || errorMessage || <div>&nbsp;</div>}</GlobalMessage>
          </div>
          <DarkButton className={buttonClass} type="submit" disabled={isDisableButton}>
            {icon}
            {loading ? 'PROCESSING' : 'SAVE NEW PASSWORD'}
          </DarkButton>
        </form>
      </CompanyPageWrapper>
    );
  }
}
